export enum STATUS {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}

export enum PERK_REDEMPTION_STATUS {
  PRE_REDEEMED = "PreRedeemed",
  PENDING_EXTERNAL_VALIDATION = "PendingExternalValidation",
  PENDING_EXTERNAL_MANUAL_VALIDATION = "PendingExternalManualValidation",
  INVALIDATED = "Invalidated",
  REDEEMED = "Redeemed",
}

export enum PERK_REDEMPTION_STATUS_USER_FACING {
  PRE_REDEEMED = "Pre Redeemed",
  PENDING_EXTERNAL_VALIDATION = "Pending Validation",
  PENDING_EXTERNAL_MANUAL_VALIDATION = "Pending Manual Validation",
  INVALIDATED = "Fail",
  REDEEMED = "Success",
}

export const REDEMPTION_STATUS_TO_USER_FACING: Record<
  string,
  PERK_REDEMPTION_STATUS_USER_FACING
> = {
  [PERK_REDEMPTION_STATUS.PRE_REDEEMED]:
    PERK_REDEMPTION_STATUS_USER_FACING.PRE_REDEEMED,
  [PERK_REDEMPTION_STATUS.PENDING_EXTERNAL_VALIDATION]:
    PERK_REDEMPTION_STATUS_USER_FACING.PENDING_EXTERNAL_VALIDATION,
  [PERK_REDEMPTION_STATUS.PENDING_EXTERNAL_MANUAL_VALIDATION]:
    PERK_REDEMPTION_STATUS_USER_FACING.PENDING_EXTERNAL_MANUAL_VALIDATION,
  [PERK_REDEMPTION_STATUS.INVALIDATED]:
    PERK_REDEMPTION_STATUS_USER_FACING.INVALIDATED,
  [PERK_REDEMPTION_STATUS.REDEEMED]:
    PERK_REDEMPTION_STATUS_USER_FACING.REDEEMED,
}
